import {verify} from 'jsonwebtoken';
import CONFIG from './config';

export default class AuthService {

    // constructor() {
    //     console.log("AUTH SERVICE");
    // }

    setToken = token => {

        console.log(token);
        localStorage.setItem("api_token", token);

    }

    getToken = () => {
        return localStorage.getItem("api_token");
    }

    verifyToken = () => {

        return new Promise( resolve => {

            var token = localStorage.getItem("api_token");
            console.log("tokentokentokentoken", token)
            if (!token) {
                resolve(false);
                return;
            }

            verify(token, CONFIG.JWT.secret, (err, decoded) => {
                console.log(err, decoded)
                if (err) {
                    console.log("tokenerror", err)
                    localStorage.removeItem("api_token")
                    localStorage.removeItem("username")
                    resolve(false);
                }

                if (decoded) {
                    localStorage.setItem("username", decoded.username);
                    resolve(true);
                }
    
            });


        })

    }
}